import React, { useState } from "react";
import notif from "../../assets/images/Icon material-notifications-none.png";
import arrow from "../../assets/images/Icon material-keyboard-arrow-left.png";
const Message = ({ message, index }) => {
  const [openMessage, setOpenMessage] = useState(false);
  var date = new Date(message.mtm * 1000);
  if (index < 5)
    return (
      <div
        className="card col-10"
        onClick={(e) => setOpenMessage(!openMessage)}
        key={index}
      >
        <div className="col-12 sender">ارسال شده توسط {message.shopTitle}</div>
        <div className="header">
          <div className="header1">
            {openMessage ? (
              <>
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                  عنوان :
                </span>
                <span style={{ marginRight: "5px", color: "#707070" }}>
                  {message.title}
                </span>
              </>
            ) : (
              <>
                <div className="TI">
                  <div className="icon">
                    <img src={notif} alt="notification" />
                  </div>
                  <span style={{ fontSize: "18px" }}>عنوان پیام </span>
                </div>
                <span style={{ marginRight: "5px", color: "#707070" }}>
                  {message.title}
                </span>
              </>
            )}
          </div>
          <div className="header2">
            <div>{date.toLocaleDateString("fa-IR")}</div>
            <div style={{ marginRight: "20px" }}>
              <img src={arrow} alt="arrow" />
            </div>
          </div>
        </div>
        {openMessage ? (
          <>
            <hr />
            <div className="text">
              <div style={{ fontSize: "16px", fontWeight: "bold" }}>متن </div>
              <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                {"  :  "}
              </div>
              <div style={{ marginRight: "5px", color: "#707070" }}>
                {message.description}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    );
  else return "";
};

export default Message;
